import OptionRepository from "@adapters/features/Markets/Options/Repository/Options";
import CommonRepo from "@adapters/features/Markets/Common/CommonRepo";
import { qouteStream } from "@mainDi/streamerDi";
export default (function (http) {
    return {
        common: new CommonRepo(http),
        option: new OptionRepository(http),
        qouteStream: qouteStream,
    };
});
